module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTDIyMjAwMDExMTAwMDIyMjMzMzAwMDIyMjIyMjMzMzIyMjMzM823RR8AAAAMdFJOUwDAQD8amfAwUNywegkZdooAAAB7SURBVCjPY2CgDigVhADpBqhAzhkoOArhM51U0jmkBAStZxwgAgcZeA6AWXMU0ARkkAVcpRRQBWrOBKAKMCk7oApgmEFYwEuQkC3sSgwU20KmACyAThrbHDYGgtZj6IGcARXwFpQ5CIqG1Q7wmIGagQBsCWgCLA644xUAoexCMYvp8pkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/myreports.png
// module id = 79
// module chunks = 0